(function () {
    'use strict';
    app.controller('indexController', ['$rootScope', '$scope', '$location', '$cookies', 'AuthenticationService', 'LoginService', 'progressBarService', '$route', '$http', function ($rootScope, $scope, $location, $cookies, AuthenticationService, loginService, progressBarService, $route, $http) {

        $scope.logOut = function () {
            if ($rootScope.buildConfig.aippSurveyOn) {
                $('#survayDetails').appendTo("body").modal('show');
            }
            else {
                loginService.logOut();
                $location.path('/home');
            }

        }
        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        $rootScope.PlotGraphLinkCSS = 'disabled';
        $rootScope.SaveWorkspaceLinkCSS = '';
        $scope.closeBrowser = function () {
            $('#survayDetails').appendTo("body").modal('show');

        }

        $rootScope.isSA = getLocalValue('userRole') == 'SAdmin';

        $scope.reloadCaptcha = function () {
            $rootScope.$broadcast('reloadCaptcha', {});
        }

        $('#survayDetails').on('hide.bs.modal', function () {
            loginService.logOut();
            $location.path('/home');
        });

        $scope.redirectToLanding = function () {
            if (getLocalValue('userRole') == 'SAdmin') {
                $rootScope.PlotGraphLinkCSS = 'disabled';
                $rootScope.SaveWorkspaceLinkCSS = '';
                $location.path('admin/landing');

            }
            else if (getLocalValue('userRole') == undefined) {

                $location.path('home');
            }
            else {
                $rootScope.PlotGraphLinkCSS = 'disabled';
                $rootScope.SaveWorkspaceLinkCSS = '';
                $location.path('landing');
            }
        }

        $scope.isAuthenticated = false;
        $scope.fullName = '';
        $scope.institute = '';
        $rootScope.isSA = getLocalValue('userRole') == 'SAdmin' ? true : false;
        $rootScope.isForgotPassword = false;

        $("body").on('click', '.forgotpassword', function () {
            $rootScope.$broadcast('reloadCaptcha', {});
            angular.element("#forgotPassword").click();
        });

        $scope.forgotPassword = function () {
            $rootScope.$broadcast('reloadCaptcha', {});
            $rootScope.isForgotPassword = true;
            $("form[name=forgotPasswordForm]").trigger('reset');
            $('.border-red').removeClass('border-red');
            $rootScope.$broadcast('forgotPassword');
            $('form#forgot-nav #forgotEmailId').val($('form#login-nav #userName').val());
        };
        // loginService.getInstituteName();
        $scope.isAutorenewed = false;

        var authData = AuthenticationService.getTokenInfo();
        if (authData) {
            //$scope.userName = authData.userName;
            $scope.isAuthenticated = true;
            $scope.fullName = getLocalValue('fullName');
            $scope.institute = $cookies.get('institute');
            getObjectTechniques();
            if ($location.$$path == '/home') {
                if (getLocalValue('userRole') == 'SAdmin') {
                    $location.path('/admin/landing');
                } else {
                    $location.path('/landing');
                }
            }
        }

        $(".linkToAccessOption").click(function (e) {
            if (authData) {
            } else {
                if ($location.$$path == '/home') {
                    $("body, html").animate({
                        scrollTop: $("#accessOptionContainer").offset().top
                    }, 600);
                }
            }
        });

        // to avoid multiple events on loginSuccess
        var destroyLogin;

        destroyLogin = $scope.$on('loginSuccess', function (event, args) {

            if ($scope.institute == '') {
                $scope.userName = args.userName;
                $scope.isAuthenticated = true;
                $scope.isAutorenewed = getLocalValue('isAutorenewed') === "1" ? true : false;
            }
            getObjectTechniques();
            loginService.setUserDetail(args.userName).then(function (response) {
                if ($rootScope.urlworkspaceid != null && $rootScope.urlworkspaceid != '' && $rootScope.isFirstLogin == '0') {
                    $location.path('/plotgraph');
                }
                else {
                    $rootScope.urlworkspaceid = null;
                    if (getLocalValue('userRole') == 'SAdmin') {


                        $location.path('/admin/landing');
                    } else {
                        $location.path('/landing');

                    }
                }
            });

            progressBarService.hideProgressBar();
        });

        $scope.$on('logoutSuccess', function (event, args) {
            $scope.userName = '';
            $scope.isAuthenticated = false;
            $scope.fullName = '';
            $scope.institute = '';
            $scope.isAutorenewed = false;
            $scope.teamInfoBanner = undefined;
        });

        $scope.$on('setUserSuccess', function (event, args) {
            if ($scope.fullName != args.fullName) {
                $scope.fullName = args.fullName;
            }
        });

        $scope.$on('$destroy', function () {
            destroyLogin(); // remove listener.
        });

        function getObjectTechniques() {
            $http({
                method: "GET",
                url: serviceBase + "getObjectTechniques",
                headers: {
                    'Content-Type': 'application/json'
                }
            }).success(function (data, headers, status) {
                if (getLocalValue("objectTechniques") == undefined) {
                    setLocalValue("objectTechniques", data);
                }
                getTeamInfo();
            });
        }

        function getTeamInfo() {
            $http({
                method: "GET",
                url: serviceBase + "api/Account/teamInfo",
                headers: {
                    'Content-Type': 'application/json'
                }
            }).success(function (data, headers, status) {
                $scope.teamInfoBanner = data;
            });
        }

        $scope.$on('getTeamInfo', function () {
            getTeamInfo();
        });

        function setFooter() {
            progressBarService.showProgressBar();

            $http({
                method: "GET",
                url: serviceBase + "globalValues",
                headers: {
                    'Content-Type': 'application/json'
                }
            }).success(function (data, headers, status) {

                var freeUserSpaceSize = data.loginFreeUserSpaceSize.slice(0, -2);
                var premUserSpaceSize = data.loginPremUserSpaceSize.slice(0, -2);
                var surveyMonkeyPopupLoadTime = data.surveyMonkeyPopupLoadTime;

                $rootScope.LoginFreeUserSpaceSize = freeUserSpaceSize < '1000' ? freeUserSpaceSize + 'MB' : freeUserSpaceSize / 1000 + 'GB';
                $rootScope.LoginPremUserSpaceSize = premUserSpaceSize < '1000' ? premUserSpaceSize + 'MB' : premUserSpaceSize / 1000 + 'GB';

                $rootScope.SurveyMonkeyPopupLoadTime = surveyMonkeyPopupLoadTime;

                setCookie("loginFreeUserSpaceSize", $rootScope.LoginFreeUserSpaceSize, $cookies);
                setCookie("loginPremUserSpaceSize", $rootScope.LoginPremUserSpaceSize, $cookies);
                setCookie("surveyMonkeyPopupLoadTime", $rootScope.SurveyMonkeyPopupLoadTime, $cookies);

                var monthlyPrice = data.productPackMonthlyPrice.toString().split('.');
                if (monthlyPrice.length > 1) {
                    $rootScope.ProductPackMonthlyPriceInDollar = monthlyPrice[0];
                    $rootScope.ProductPackMonthlyPriceInCents = monthlyPrice[1];
                } else {
                    $rootScope.ProductPackMonthlyPriceInDollar = monthlyPrice[0];
                }
                $rootScope.ProductPackYearlyPrice = data.productPackYearlyPrice;
                setCookie("productPackMonthlyPrice", data.productPackMonthlyPrice, $cookies);
                setCookie("productPackYearlyPrice", data.productPackYearlyPrice, $cookies);
                setCookie("versionNo", data.applicationVersionNumber, $cookies);
                $rootScope.applicationVersionNo = data.applicationVersionNumber;
                $('#copyRightYear').text(new Date().getFullYear());
                $('#appVersion strong').html(getCookie("versionNo", $cookies));

                progressBarService.hideProgressBar();
            })
        }

        $scope.$on('setFooter', function () {
            setFooter(); 
        });

        if (getCookie("versionNo", $cookies) === undefined || getCookie("versionNo", $cookies) == "" || getCookie("versionNo", $cookies) == null) {//($cookies.get("versionNo") === undefined || $cookies.get("versionNo") == "" || $cookies.get("versionNo") == null) {
            setFooter();
        } else {
            $rootScope.LoginFreeUserSpaceSize = getCookie("loginFreeUserSpaceSize", $cookies);
            $rootScope.LoginPremUserSpaceSize = getCookie("loginPremUserSpaceSize", $cookies);

            var monthlyPrice = getCookie("productPackMonthlyPrice", $cookies).toString().split('.');
            if (monthlyPrice.length > 1) {
                $rootScope.ProductPackMonthlyPriceInDollar = monthlyPrice[0];
                $rootScope.ProductPackMonthlyPriceInCents = monthlyPrice[1];
            } else {
                $rootScope.ProductPackMonthlyPriceInDollar = monthlyPrice[0];
            }

            $rootScope.ProductPackYearlyPrice = getCookie("productPackYearlyPrice", $cookies);
            $('#copyRightYear').text(new Date().getFullYear());
            $('#appVersion strong').html(getCookie("versionNo", $cookies));
        }
    }]);
})();